import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Store} from "@ngrx/store";
import {AppState} from "../../store/state/app.state";
import {Order} from "../../store/state/order.state";
import {orderSelector} from "../../store/state/state.selectors";
import {mergeMap} from "rxjs/operators";
import {AdditionalQuestionsData} from "../../store/actions/order.actions";
import {ClientOrderResolver} from "./client-order-resolver.service";
import {EndpointsProvider} from "../../umbrella-common/endpoints/endpoint-provider.service";

@Injectable()
export class AdditionalQuestionsDataFetchResolver implements Resolve<AdditionalQuestionsData> {

	private order$: Observable<Order>;

	constructor(private endpoints: EndpointsProvider, private store: Store<AppState>, private orderResolver: ClientOrderResolver) {
		this.order$ = this.store.select(orderSelector);
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AdditionalQuestionsData> {
		return this.orderResolver.resolve(route, state).pipe(mergeMap(order => this.fetchAdditionalQuestionsData(order)));
	}

	private fetchAdditionalQuestionsData(order: Order): Observable<AdditionalQuestionsData> {
		return this.endpoints.client.getAdditionalQuestionsDataFor(order);
	}
}
